<template>
    <div class="photo-pick">
        <div class="content">
            <div class="left">
                <zk-table
                    class="table"
                    ref="table"
                    :data="category"
                    :columns="columns"
                    :stripe="config.stripe"
                    :border="config.border"
                    :show-header="config.showHeader"
                    :show-summary="config.showSummary"
                    :show-row-hover="config.showRowHover"
                    :show-index="config.showIndex"
                    :tree-type="config.treeType"
                    :is-fold="config.isFold"
                    :expand-type="config.expandType"
                    :selection-type="config.selectionType"
                    @tree-icon-click="review_children"
                    >
                    <template slot="likes" scope="scope">
                        <button style="background-color: rgb(33, 165, 250); border-radius: 5px; color: white; padding: 6px; border: 1px white solid;" @click="search_category(scope.row)">查询</button>
                   </template>
                </zk-table>
            </div>
            <div class="right">
                <el-row type="flex" justify="space-between" align="middle" class="tool-tips">
                
                    <el-col align="right">
                        <!-- 这里@keyup.enter需要加上native -->
                        <el-input
                        v-model="vipname"
                        placeholder="关键字查询"
                        class="input-with-select"
                        @keyup.enter.native="handleSearch"
                        >
                        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                        </el-input>
                    </el-col>
                </el-row>

                <!-- 图片展示 -->
                <div class="imgs-content" v-if="imgs_in_category.length">
                    <div class="img-item" style="position: relative;" v-for="img in imgs_in_category" @click="img_selected(img)">
                        <!-- 暂不考虑内存压力 -->
                        <img v-if="img.ctype==1"  class="img-icon" :src="`${baseURL}/${img.source}?q=30`" alt="">
                        <video v-else-if="img.ctype == 2" :src="`${baseURL}/${img.source}`" style="width: 99px;height: 99px;object-fit: contain;"></video>
                        <div class="img-name">{{img.name}}</div>
                        <i class="iconfont icon-video" v-if="img.ctype==2" style="font-size: 40px;  position: absolute;top: 0%;right:0;"></i>
                        
                        <i v-if="!img.selected" style="position: absolute; left: 0;top: 0; color: white;font-size: 20px;" class="iconfont icon-check-unselected"/>
                        <i v-else style="position: absolute; left: 0;top: 0; color: #036BFF;font-size: 20px;font-weight: bolder;" class="iconfont icon-check_selected"/>
                    </div>
                </div>
                <span style="color: lightgray;" v-else>没有查到资源</span>

                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[2, 4, 8, 16]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalcount"
                    class="pagination"
                    >
                </el-pagination>
            </div>
        </div>
        
        <div class="bottom">
            <el-button type="primary" size="small" :disabled="!select_imgs.length" @click="submit_selected_imgs">确定</el-button>
            <el-button  size="small" style="margin-left: 50px;" @click="cancel_pick">取消</el-button>
        </div>
    </div>
</template>
  
<script>
import { all_category_list, all_filecategory_list, baseURL, eidt_filecategory, photo_list } from '../../api/api';
import { event_msg_keys } from '../../eventbus/eventkeys';
import { SystemStore } from '../../store';
import { SourceType } from '../../system/config';
    export default {
      name: 'photo-pick',
      props: {
        maxselected_num:{
            type:Number,
            default:1
        },
        //待新增类型限制
        source_type:{
            type:Number,
            default:SourceType.NoLimited
        },
        value: {
          type: Boolean,
          default: false,
        },
        disabled: {
          type: Boolean,
          default: false,
        },
      },
      data() {
        return {
          baseURL,
          default_folder_category:{
            value:0,
            id:0,
            name:'默认文件夹',
            label:'默认文件夹'
          },
          new_filefoler_dialog_show:false,
          newCategoryName:'',
          vipname:'',
          currentPage: 1,
          pageSize: 16,
          totalcount:0,
          config: {
            stripe: false,
            border: false,
            showHeader: false,
            showSummary: false,
            showRowHover: true,
            showIndex: false,
            treeType: true,
            isFold: true,
            expandType:false,
            selectionType: false,
          },
          columns: [
            {
                // label: '分类名称',
                prop: 'name',
                width: '150px',
            },
            {
            // label: '操作',
            prop: 'likes',
            // width:'150px',
            // minWidth: '200px',
            type: 'template',
            template: 'likes',
            width: '50px',
          },
           
          ],
          imgs_in_category:[],
          category:[],
          select_imgs:[],
          category_id:SystemStore().getFileCateogryId,
        };
      },
      mounted(){
        this.get_all_file_folders()
        this.getImgsInCategory(this.category_id)
      },
      computed: {
        
      },
      methods: {
       
        get_all_file_folders(){
            all_filecategory_list()
            .then(res=>{
                this.category = res.tree;
                if(!this.category.length || !this.category){
                    this.category = []
                }
                this.category.unshift(this.default_folder_category)
                this.categorysKeyAddForEach(this.category)
            })
            
        },
        categorysKeyAddForEach(arr){
            arr.forEach(item=>{
                item.value = item.id;
                item.label = item.name
                if(item.children && item.children.length){
                this.categorysKeyAddForEach(item.children)
                }else if(item.children){
                Reflect.deleteProperty(item, 'children');
                }
            })
         },
         review_children(dom,detail){
            console.log('review_children',dom,detail)
            
         },    
         search_category(v){
            this.category_id = v.id;
            this.getImgsInCategory(this.category_id)
            SystemStore().update_file_category(this.category_id)
         },
         handleSearch(){
            this.getImgsInCategory(this.category_id)
         },
           // 每页条数改变的时候
         handleSizeChange(val) {
      // 重新改变每页条数
            this.pageSize = val;
            // 并重新获取数据
            this.getImgsInCategory(this.category_id);
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getImgsInCategory(this.category_id);
        },
        //感觉应该区分一个资源类型，一个选择类型。
        getImgsInCategory(category_id){
            photo_list({ctype:this.source_type,category_id,page:this.currentPage,limit:this.pageSize,keyword:this.vipname})
            .then(res=>{
                this.imgs_in_category = res.list;
                this.sync_selected_status()
                this.totalcount = res.total
            })
            .catch(err=>{
                this.$message({
                    message:err,
                    showClose: true,
                    type:'error'
                })
            })
        },
        sync_selected_status(){
            this.imgs_in_category.forEach(show_img=>{
                const selected_img = this.select_imgs.filter(seled_img=>{
                    return seled_img.id == show_img.id
                })[0]
                if(selected_img){
                    show_img.selected = selected_img.selected
                }
            })
        },
        img_selected(img){
            console.log('img_selected0',img)
            if(!img.selected && this.select_imgs.length>=this.maxselected_num){
                // mark 2026-03-06
                return;
            }
            img.selected = !img.selected
            this.$forceUpdate()
            const exist_img = this.select_imgs.filter(selected_img=>{
                return selected_img.id == img.id
            })[0]

            if(img.selected && !exist_img){
                this.select_imgs.push(img)
            }else if(!img.selected && exist_img){
                this.select_imgs = this.select_imgs.filter(select_img=>{
                    return select_img.id != img.id
                })
            }


            console.log('img_selected1',img)
        },
        submit_selected_imgs(){
            this.$evt.emit(event_msg_keys.img_selected_submit_noti,{imgs:this.select_imgs})
        },
        cancel_pick(){
            this.$emit('cancel_pick')
        }
      }
    };
  </script>
  
<style lang="less">
@import url(../../style/iconfont.less);
.photo-pick{
   padding: 0px 10px;
   display: flex;
   flex-direction: column;
//    align-items: center;
   .table{
    width: 300px;
    max-height: 800px;
    overflow-y: auto;
   }
    .content{
        display: flex;
        justify-content: left;
    }
    .bottom{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }
}
.left{
    margin-top: 70px;
}
.right{
    margin-left: 20px;
    // padding-right: 40px;
    .imgs-content{
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
        .img-item{
            width: 99px;
            height: 160px;
            margin-left: 10px;
            .img-icon{
                width: 99px;
                height: 99px;
                object-fit: cover;
            }
        }

    }
}

.img-name{
  
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制行数为2 */
  overflow: hidden;
  text-overflow: ellipsis;

}

</style>
  